import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const OrgDashboardAppLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "OrgDashboard" */
      './OrgDashboardApp.dynamic'
    ),
  loading: LoadingPageLoadable,
});
